export const environment = {
  production: true,
  allowedCountries: ['NO']
};
